/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getEvent.defs.js'
export { main as default } from './getEvent.defs.js'
